module.exports = __webpack_public_path__ + "img/talktomaria.33c68fca.jpg";